'use client';

import { useId } from 'react';

import { cn } from '@platform/ui/lib/utils';

/**
 * The brand mark: two interlocking rings — the orange one in front, the ink one
 * notched where they cross so the link reads as over-and-under — beside the
 * lowercase wordmark (docs/10 §8). The ink ring and the word take the colour of
 * the text around them, so the mark reads on a light ground and a dark one
 * alike. `mark` renders the rings alone.
 */
export function Logo({ variant = 'full', className }: { variant?: 'full' | 'mark'; className?: string }) {
    const notch = useId();
    return (
        <span data-slot="logo" className={cn('inline-flex items-center gap-2 text-18 whitespace-nowrap text-foreground', className)}>
            <svg className="h-[1.35rem] w-auto shrink-0" viewBox="0 0 130 100" aria-hidden="true">
                <mask id={notch}>
                    <rect width="130" height="100" fill="#fff" />
                    <path d="M53.5 25.5 A27 27 0 0 1 71.5 39.5" fill="none" stroke="#000" strokeWidth="18" />
                </mask>
                <circle className="fill-none stroke-primary" strokeWidth="15" cx="47" cy="50" r="27" />
                <circle className="fill-none stroke-current" strokeWidth="15" cx="83" cy="50" r="27" mask={`url(#${notch})`} />
            </svg>
            {variant === 'full' ? (
                <span className="font-semibold tracking-hero lowercase">entegrepazar</span>
            ) : (
                <span className="sr-only">entegrepazar</span>
            )}
        </span>
    );
}
